var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlexible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 107",
    style: {
      enableBackground: "new 0 0 104 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E2584C;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#F5F6F6;}\r\n\t.st3{fill:#E2E1E0;}\r\n\t.st4{fill:#41555F;}\r\n\t.st5{fill:#2C424E;}\r\n\t.st6{fill:#E5E5E5;}\r\n\t.st7{fill:#3DB39E;}\r\n\t.st8{fill:#3A4C55;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M17.1,24.8H88c2.8,0,5.1,2.3,5.1,5.1v70.8c0,2.8-2.3,5.1-5.1,5.1H17.1c-2.8,0-5.1-2.3-5.1-5.1 V29.9C12.1,27.1,14.4,24.8,17.1,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st1",
    d: "M22.2,32.4h60.7c1.4,0,2.5,1.1,2.5,2.5v58.2c0,1.4-1.1,2.5-2.5,2.5H22.2 c-1.4,0-2.5-1.1-2.5-2.5V34.9C19.7,33.5,20.8,32.4,22.2,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st2",
    d: "M19.7,93.1c0,1.4,1.1,2.5,2.5,2.5h60.7c1.4,0,2.5-1.1,2.5-2.5V65.3H19.7 C19.7,65.3,19.7,93.1,19.7,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st3",
    d: "M82.9,93.1H22.2c-1.4,0-2.5-1.1-2.5-2.5v2.5c0,1.4,1.1,2.5,2.5,2.5h60.7c1.4,0,2.5-1.1,2.5-2.5 v-2.5C85.5,92,84.3,93.1,82.9,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st4",
    d: "M48.6,72.9h-6.2c2.9-3.5,8.2-8.1,8.2-12.7c0-4.2-3.4-6.9-7.5-6.9s-8,3.4-8,7.5 c0,1.3,0.8,2.4,2.5,2.4c3.2,0,1.4-5.4,5.3-5.4c1.4,0,2.5,1.2,2.5,2.5c0,1.2-0.6,2.2-1.2,3.1c-2.6,3.7-5.6,6.6-8.4,9.9 c-0.3,0.4-0.8,1-0.8,1.7c0,1.5,1.1,2.2,2.7,2.2H49c1.3,0,2.5-0.6,2.5-2.2C51.3,73.6,50.1,72.9,48.6,72.9z M66.3,64.3 c1.8-1.1,2.7-2.9,2.7-5c0-2.5-2.2-5.9-6.9-5.9c-3.6,0-7.1,2.7-7.1,5.3c0,1.2,0.8,2.4,2.1,2.4c2.2,0,1.8-3.2,4.9-3.2 c1.5,0,2.3,0.9,2.3,2.2c0,3.6-4.6,1.3-4.6,4.7c0,3.9,5.5,0.5,5.5,5.1c0,1.7-1.4,3-3,3c-3.7,0-3.2-3.8-5.4-3.8 c-1.1,0-2.5,0.9-2.5,2.2c0,2.6,3,6.1,7.8,6.1c4.6-0.1,8.2-3.4,8.2-7.3C70.3,67.5,68.7,65.4,66.3,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st5",
    d: "M19.7,61.5c-0.7,0-1.3,0.6-1.3,1.3v3.8c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3v-3.8 C20.9,62.1,20.4,61.5,19.7,61.5z M85.5,61.5c-0.7,0-1.3,0.6-1.3,1.3v3.8c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3v-3.8 C86.7,62.1,86.1,61.5,85.5,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st6",
    d: "M20.9,64h63.3v1.3H20.9V64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st7",
    d: "M49.4,36.8h6.3c1.1,0,1.9,0.8,1.9,1.9c0,1.1-0.8,1.9-1.9,1.9h-6.3c-1.1,0-1.9-0.8-1.9-1.9 C47.5,37.7,48.3,36.8,49.4,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st8",
    d: "M43.7,64l-0.9,1.3h6l0.8-1.3H43.7z M66.6,64h-6.8c-0.1,0.2-0.1,0.4-0.1,0.7 c0,0.3,0,0.4,0.1,0.6H68c-0.5-0.4-1.1-0.8-1.6-1.1L66.6,64z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexible);
export default __webpack_public_path__ + "static/media/flexible.adf4e01c502887786e640c540202b540.svg";
export { ForwardRef as ReactComponent };